import * as React from 'react'
import styled from 'styled-components'
import colors from 'utils/colors'

interface CustomChipLableProps {
  label: string
  backgroundColor?: string
  textColor?: string
  variant?: 'success' | 'danger' | 'warning' | 'info' | 'primary' | 'secondary'
  className?: string
}

const variantColors = {
  success: {
    bg: '#ddf6e8',
    color: colors.green,
  },
  danger: {
    bg: '#ffe0db',
    color: colors.red,
  },
  warning: {
    bg: '#fff3e0',
    color: colors.yellow,
  },
  info: {
    bg: colors.vime10,
    color: colors.vime,
  },
  primary: {
    bg: colors.light70,
    color: colors.primaryVime,
  },
  secondary: {
    bg: colors.gray20,
    color: colors.gray80,
  },
}

const CustomChipLable: React.FC<CustomChipLableProps> = ({
    label,
    backgroundColor,
    textColor,
    variant = 'success',
    className,
  }) => {
    const colorOfVariant = variant
      ? variantColors[variant]
      : { bg: colors.gray20, color: colors.gray80 }
  
    const finalBackgroundColor = backgroundColor || colorOfVariant.bg
    const finalTextColor = textColor || colorOfVariant.color
  
    return (
      <StyledBadge
        className={className}
        $backgroundColor={finalBackgroundColor}
        $textColor={finalTextColor}
      >
        {label}
      </StyledBadge>
    )
  }

export default CustomChipLable

const StyledBadge = styled.span<{ $backgroundColor: string; $textColor: string }>`
  display: inline-block;
  padding: 0.4235em 0.77em;
  font-size: 0.8667em;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  cursor: default;
  background-color: ${(props) => props.$backgroundColor} !important;
  color: ${(props) => props.$textColor} !important;
`